export class Constants {
    public static FiveYearHyCoReportAnalysisFilterLabelText = "Announcements for 5 Year Ending";
    public static OneYearHyCoReportAnalysisFilterLabelText = "Announcements for 1 Year Ending";

    public static OneYearAnalysisHyCoReportPageTitleText = "1 Year Analysis";
    public static FiveYearAnalysisHyCoReportPageTitleText = "5 Year Analysis";
    public static RegionalAnalysisHyCoReportPageTitleText = "Regional Analysis";
    public static AwardDetailsHyCoReportPageTitleText = "Award Details";

    public static OneYearAnalysisHyCoReportLinkText = "1-Yr Analysis";
    public static FiveYearAnalysisHyCoReportLinkText = "5-Yr Analysis";
    public static RegionalAnalysisHyCoReportLinkText = "Regional Analysis";
    public static AwardDetailsHyCoReportLinkText = "Award Details";


    public static industrialGas_Syngas: number = 1;
    public static industrialGas_Steam: number = 2;
    public static industrialGas_Power: number = 3;
    public static industrialGas_Other: number = 5;

    public static material_Syngas: number = 41;
    public static material_Steam: number = 40;
    public static material_Power: number = 34;
    public static material_Other: number = 32;
  }